var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BixLink',{staticClass:"skip-link sr-only sr-only-focusable",attrs:{"href":"#main-content"}},[_vm._v("\n  Skip to content\n")])}
var staticRenderFns = []

export { render, staticRenderFns }